module.exports = __webpack_public_path__ + "shopping/img/banner.39d9790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = Yz7+
// module chunks = 1